import { createContext } from 'react';

import { useNewbuildingBrokerWidget } from './hooks';

type TValue = ReturnType<typeof useNewbuildingBrokerWidget>['openWidget'];

export const NewbuildingBrokerWidgetContext = createContext<TValue>(() => Promise.resolve());
